import React from 'react';

import { Counter } from '@/components';
import { NOT_DEFINED } from '@/constants';

import {
  getDefaultProductInfoComponents,
  ProductActionFavorite,
  ProductBadgeContainer,
  ProductImage,
  ProductInfoCarousel,
  ProductLinkWrapper,
  ProductName,
  ProductPrice,
  ProductVariants,
} from '../Product.components';
import { ProductVariationProps } from '../Product';
import { useProductContext } from '../context';

import classNames from 'classnames';
import style from '../product.module.scss';
import styleVariation from './ProductCardWithBtnSmall.module.scss';

const ProductCardWithSmallBtn: React.FC<ProductVariationProps> = ({
  className,
  analyticsListName,
  isLargeCard,
}) => {
  const { product, variants, isSpecial, weightVariant, compoundList } =
    useProductContext();

  const availableInfo = getDefaultProductInfoComponents(product, compoundList);

  return (
    <ProductLinkWrapper
      analyticsListName={analyticsListName}
      className={classNames(style.product, styleVariation.product, className)}
      product={product}
    >
      <ProductImage
        className={styleVariation.product__image_container}
        product={product}
      />
      <div className={style.product__body}>
        <ProductBadgeContainer
          className={styleVariation.product_badge__container}
          key="badge-container"
          product={product}
          weightVariant={weightVariant}
        />
        <ProductInfoCarousel
          className={styleVariation.variation__info_carousel}
        >
          {availableInfo}
        </ProductInfoCarousel>
        <ProductName name={product?.name || NOT_DEFINED} />
        <div className={styleVariation.product__actions_footer}>
          <ProductPrice
            elementVariants={<ProductVariants />}
            isOverflow={variants?.length === 1}
            isSpecial={isSpecial}
            type="column-container"
            weightVariant={weightVariant}
          />
          <Counter
            actionTheme="primary"
            className={classNames(styleVariation.actions__counter, {
              [styleVariation.actions__counter_large_card]: isLargeCard,
            })}
            omitCheckAvilibility
            onCard
            product={product}
            selectedWeightVariant={weightVariant}
            showIcon
          />
        </div>
        <div className={styleVariation.actions__body}>
          <ProductActionFavorite
            className={classNames(
              style.favorite_action,
              styleVariation.favorite__button,
            )}
            product={product}
          />
        </div>
      </div>
    </ProductLinkWrapper>
  );
};

export { ProductCardWithSmallBtn };
